import React, { useState } from 'react';
import { useStore } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import API from '../../../create/api';
import Grid from '@material-ui/core/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Company from '../../../fields/company';
import clsx from 'clsx';
import LinearProgress from '@mui/material/LinearProgress';
import { TableHead } from '@mui/material';
import querystring from 'querystring';
import _ from 'lodash';
import { Box } from '@mui/system';
import moment from 'moment';
import { updateLastCompanyAndClearParcelIds } from '../../../../store/thunk-actions';
import { type AnyAction } from 'redux';
const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
    '& .MuiTableCell-root': {
      border: '1px solid #c7c7c7',
    },
  },
  tableBorder: {
    '& .MuiTableCell-root': {
      border: '1px solid #c7c7c7',
    },
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  fromControl: {
    width: '100%',
  },
  createButton: {
    paddingBottom: theme.spacing(2),
  },
  centerAlign: {
    textAlign: 'center',
    'span &': {
      verticalAlign: 'middle',
    },
  },
  tdBorder: { border: '1px solid black ', fontSize: '20px', padding: '0 5px' },
  onlyPrint: { display: 'none' },
  hidePrint: {},
  '@media print': {
    'table tr': {
      pageBreakBefore: 'always',
    },
    hidePrint: {
      display: 'none',
    },
    onlyPrint: { display: 'block' },
    printStyle: {
      border: '1px solid  black',
      fontSize: '20px',
      padding: '0 5px',
    },
    numberSize: { fontSize: '30px' },
  },
}));

export default function SpanningTable() {
  const classes = useStyles();
  const store = useStore();

  // first fetch
  const [rows, setRows]: [any, any] = useState([]);
  const [get_parcel_date_from, set_parcel_date_from] = useState(moment().format('YYYY-MM-DD'));
  const [get_parcel_date_to, set_parcel_date_to] = useState(null);

  // table filter
  const [company, setCompany]: any = useState(store.getState().parcel?.last_company ?? null);
  const [companyInfo, setcompanyInfo]: any = useState(null);
  const [loading, setLoading]: any = useState(false);
  const [getSubtotalParcel, setSubTotalParcel]: any = useState(0);
  const [getSubTotalPayment, setSubTotalPayment]: any = useState(0);
  const [getTotalDc, setTotalDc]: any = useState(0);

  async function getDailyBalance() {
    setLoading(true);
    if (company?.value) {
      const param: Record<string, any> = {
        company: company?.value,
        _sort: 'created_at:ASC',
        addToBalance: true,
        _limit: -1,
      };

      if (get_parcel_date_from && !get_parcel_date_to) {
        param.booking_date = get_parcel_date_from;
      }
      if (get_parcel_date_from && get_parcel_date_to) {
        param.booking_date_gte = get_parcel_date_from;
        param.booking_date_lte = get_parcel_date_to;
      }

      const qs = querystring.encode(_.pickBy(param, _.identity));
      const parcelUrl = `${process.env.REACT_APP_API_SERVER}/parcels?${qs}`;

      delete param.addToBalance;
      const qsPayment = querystring.encode(_.pickBy(param, _.identity));
      const paymentUrl = `${process.env.REACT_APP_API_SERVER}/payments?${qsPayment}`;

      const url_company = `${process.env.REACT_APP_API_SERVER}/companies`;
      API.get(url_company, company?.value).then((company_info: any) => {
        setcompanyInfo(company_info);
      });

      await API.getAll(paymentUrl).then((payments: any) => {
        let subTotalPayment = 0;

        for (let i = 0; i < payments.length; i++) {
          const row = payments[i];
          subTotalPayment = subTotalPayment + (row.amount ?? 0);
        }

        setSubTotalPayment(subTotalPayment);
      });

      await API.getAll(parcelUrl)
        .then((dailyBalances: any) => {
          const rows = [];
          let subTotalParcel = 0;
          let totalDC = 0;

          for (let i = 0; i < dailyBalances.length; i++) {
            const row = dailyBalances[i];

            rows.push({
              Booking: row?.booking_date,
              APN: `parcel: ${row?.id}`,
              Invoice: row.memoNo,
              Customer: row.customerName,
              DC: row.deliveryCharge,
              Amount: row.amount + row.deliveryCharge,
            });
            subTotalParcel = subTotalParcel + (row.amount ?? 0);
            totalDC = totalDC + (row.deliveryCharge ?? 0);
          }

          setSubTotalParcel(subTotalParcel);
          setTotalDc(totalDC);
          setRows(rows);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setRows([]);
    }
  }

  const handlePrint = () => {
    store.dispatch({ type: 'CLOSE_SIDEBAR' });
    setTimeout(() => {
      window.print();
    }, 100);
  };

  return (
    <Grid container>
      <Grid item xs={12} className={classes.createButton}>
        {loading && <LinearProgress />}
      </Grid>
      <Grid item xs={12} className={clsx(classes.createButton, classes.hidePrint)} component={Paper}>
        <Grid container style={{ padding: '5px' }}>
          <Grid item xs={3}>
            <Company
              onChange={(cp: any) => {
                setCompany(cp ?? null);
                store.dispatch(updateLastCompanyAndClearParcelIds(cp) as unknown as AnyAction);
              }}
              defaultValue={store.getState().parcel?.last_company}
            />
          </Grid>
          <Grid item xs={3} style={{ marginLeft: '10px' }}>
            Start:
            <br />
            <TextField
              label=""
              type="date"
              variant="standard"
              value={get_parcel_date_from}
              onChange={(e) => {
                const date: any = e.target.value ?? '';
                set_parcel_date_from(date);
              }}
            />
          </Grid>
          <Grid item xs={3}>
            End:
            <br />
            <TextField
              type="date"
              variant="standard"
              value={get_parcel_date_to}
              onChange={(e) => {
                const date: any = e.target.value ?? '';
                set_parcel_date_to(date);
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <Button
              sx={{ marginTop: '10px' }}
              size="small"
              variant="contained"
              color="primary"
              onClick={getDailyBalance}
            >
              Search
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={{ marginTop: '10px', marginLeft: '20px' }}
              color="primary"
              onClick={handlePrint}
            >
              Print
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid xs={12} className={clsx(classes.onlyPrint, classes.createButton)}>
        <Grid item xs={12} className={classes.createButton}>
          <h1 style={{ textAlign: 'center' }}>Invoice</h1>
          <hr style={{ borderTop: '5px solid black' }} />
        </Grid>
        <Grid container>
          <Grid xs={6}>
            <div style={{ marginLeft: '15%' }}>
              <h6 style={{ textDecoration: 'underline' }}> Invoice from:</h6>
              <h1> {process.env.REACT_APP_COURIER_COMPANY_NAME} </h1>
              <div>
                <h5
                  dangerouslySetInnerHTML={{
                    __html: String(process.env.REACT_APP_COURIER_COMPANY_ADDRESS?.replaceAll('\n', '<br/>')),
                  }}
                ></h5>
              </div>
            </div>
          </Grid>
          <Grid xs={6}>
            <div
              style={{
                paddingLeft: '15%',
                borderLeft: '2px solid black',
              }}
            >
              <h6 style={{ textDecoration: 'underline' }}> Invoice to:</h6>
              <h1> {company?.label} </h1>
              <h5>ID: {companyInfo?.id}</h5>
              <h5>Phone: {companyInfo?.username}</h5>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.createButton}>
            <hr style={{ borderTop: '5px solid black' }} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.createButton} style={{ marginTop: '10px' }}>
        <TableContainer component={Paper}>
          <Table className={classes.table}>
            <TableHead style={{ backgroundColor: 'lightgray' }}>
              <TableRow>
                <TableCell>
                  <b>Booking</b>
                </TableCell>
                <TableCell>
                  <b>APN</b>
                </TableCell>
                <TableCell align="right">
                  <b>Invoice</b>
                </TableCell>
                <TableCell align="left">
                  <b>Customer</b>
                </TableCell>
                <TableCell align="right">
                  <b>DC</b>
                </TableCell>
                <TableCell align="right">
                  <b>Amount</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row: any) => (
                <TableRow key={row.id}>
                  <TableCell component="th" scope="row">
                    {row?.Booking}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row?.APN}
                  </TableCell>
                  <TableCell align="right">{row?.Invoice}</TableCell>
                  <TableCell align="left">{row?.Customer}</TableCell>
                  <TableCell align="right">{row?.DC}</TableCell>
                  <TableCell align="right">{row?.Amount}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Grid container justifyContent="flex-end" style={{ backgroundColor: '#fff', border: '1px solid #c7c7c7 ' }}>
          <Grid item xs={4}>
            <Box style={{ width: '100%' }}>
              <Table className={classes.tableBorder}>
                <TableRow>
                  <TableCell>Summary</TableCell>
                  {get_parcel_date_from && (
                    <TableCell>
                      {get_parcel_date_from && !get_parcel_date_to
                        ? get_parcel_date_from
                        : `${get_parcel_date_from} to  ${get_parcel_date_to}`}
                    </TableCell>
                  )}
                  {!get_parcel_date_from && !get_parcel_date_to && <TableCell>Date</TableCell>}
                </TableRow>
                <TableRow>
                  <TableCell>Subtotal Parcel</TableCell>
                  <TableCell align="right">{getSubtotalParcel + getTotalDc}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Delivery Charge</TableCell>
                  <TableCell align="right">{getTotalDc}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Total</TableCell>
                  <TableCell align="right">{getSubtotalParcel}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Subtotal Payment</TableCell>
                  <TableCell align="right">{getSubTotalPayment}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Due</TableCell>
                  <TableCell align="right">{getSubtotalParcel - getSubTotalPayment}</TableCell>
                </TableRow>
              </Table>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
